(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('noNg', function() {
    return {
      priority: 1000,
      compile: function(elem, attrs) {
        return attrs.$set('ngClick', '$event.stopPropagation()');
      }
    };
  });

}).call(this);
